<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
          <div class="padding">
          <p>i walked through the Ribbonway today</p>

          <p>and i knew that if we had met,</p>

          <p>this is where we would have met.</p>

          <p>Now I find myself looking around while I walk,</p>

          <p>and at every corner I wonder if something happened to me there that I just don't remember,</p>

          <p>if it's a place of significance that somehow I've let go of. . .</p>
           <p> &nbsp;</p>
          <p> &nbsp;</p>
          </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Repeat'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
